import { DialogTitle, FormGroup, Grid, styled, SvgIcon } from "@mui/material";

export const StyledReintegros = {
    BreadcrumbContainer: styled("div")(({ theme }) => ({
        display: "flex",
        margin: "15px",
    })),
    TitleFormContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        padding: "20px",
    })),
};

export const StyledSiniestro = {
    WarningMessageContainer: styled("div")(({ theme }) => ({
        display: "flex",
        padding: "15px",
    })),
    Container: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    })),
    FormContainer: styled("div")(({ theme }) => ({
        width: "50%",
        height: "100%",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        padding: "20px",
    })),
    TableContainer: styled("div")(({ theme }) => ({
        width: "65%",
    })),
    ErrorContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        marginBottom: "20px",
    })),
    TableFooter: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        padding: "20px",
    })),
};

export const StyledBeneficiarios = {
    Container: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        padding: "35px",
    })),
    FormContainer: styled("div")(({ theme }) => ({
        width: "70%",
    })),
    TextFieldContainer: styled("div")(({ theme }) => ({
        marginTop: "35px",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
    })),
    CheckboxContainer: styled("div")(({ theme }) => ({
        marginTop: "35px",
        display: "flex",
    })),
    FormGroup: styled(FormGroup)(({ theme }) => ({
        padding: "0px 0px 0px 20px",
    })),
};

export const StyledDatosComprobante = {
    Container: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        padding: "20px",
    })),
    FormContainer: styled("div")(({ theme }) => ({
        width: "100%",
    })),
    TableContainer: styled("div")(({ theme }) => ({
        width: "65%",
    })),
    Icon: styled(SvgIcon)(({ theme }) => ({
        marginLeft: "10px",
    })),
    TableFooter: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
    })),
    TableButtonContainer: styled("div")(({ theme }) => ({
        margin: "30px 25px 0px 0px",
        "& button": {
            marginLeft: "10px",
        },
    })),
    DialogButtonContainer: styled(Grid)(({ theme }) => ({
        display: "flex",
        justifyContent: "flex-end",
    })),
    GridContainer: styled(Grid)(({ theme }) => ({
        marginTop: "8px",
        padding: "20px",
    })),
    DialogInputContainer: styled(Grid)(({ theme }) => ({
        paddingBottom: "8px",
    })),
};

export const StyledComprobante = {
    Container: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    })),
    DataContainer: styled("div")(({ theme }) => ({
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    })),
    Icon: styled(SvgIcon)(({ theme }) => ({
        marginLeft: "10px",
        cursor: "pointer",
    })),
    DialogTitle: styled(DialogTitle)(({ theme }) => ({
        backgroundColor: theme.palette.primary.main,
        color: "white",
    })),
}